import React, { useState, useEffect } from 'react';
import { Map } from 'immutable';

import { ImageFromField } from '@uncinc/react-drupal-core';

import {
  BlobWrapper,
} from '../../../../../components';

import {
  SCREEN_MOBILE,
  SCREEN_NORMAL,
  SCREEN_WIDE,
} from '../../../../../config/constants';

const ColleagueCollageItem = ({ entity, mobile }) => {
  const [animationOffsets, setAnimationOffsets] = useState({ x: 0, y: 0 });
  const [size, setSize] = useState(0);
  const maxAnimationOffset = 5;

  const image = entity.getIn(['field_hero', 0]);

  let maxSize = 200;
  let minSize = 114;

  if (mobile) {
    maxSize = 100;
    minSize = 40;
  }

  const randomize = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1) + min);
  };

  useEffect(() => {
    setSize(randomize(minSize, maxSize));
  }, [minSize, maxSize]);

  useEffect(() => {
    setTimeout(() => {
      setAnimationOffsets({
        x: randomize(-maxAnimationOffset, maxAnimationOffset),
        y: randomize(-maxAnimationOffset, maxAnimationOffset),
      });
    }, randomize(500, 1500));
  }, [animationOffsets]);

  return (
    <div
      className="ColleagueCollage__item"
      style={{ transform: `translateX(${animationOffsets.x}px) translateY(${animationOffsets.y}px)` }}
    >
      <BlobWrapper style={{
        width: size,
        height: size,
      }}>
        <ImageFromField
          field={image}
          imageStyles={Map({
            [SCREEN_MOBILE]: 'cropped_standard_collage',
            [SCREEN_NORMAL]: 'cropped_standard_collage',
            [SCREEN_WIDE]: 'cropped_standard_collage',
          })}
          lazyload
        />
      </BlobWrapper>
    </div>
  );
};

export default ColleagueCollageItem;
